import API_URLS from '../links';

export const getMembershipPlan = (creds,gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_MEMBERSHIP_PLANS  + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token,
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addMembershipPlan = (creds, values) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_MEMBERSHIP_PLAN, {
        method: 'POST',
        headers: {
          access_token: creds.access_token,
          'Content-type': 'application/json',
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteMembershipPlan = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_MEMBERSHIP_PLAN + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateMembershipPlan = (creds, values, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_MEMBERSHIP_PLAN + `/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token,
          'Content-type': 'application/json'
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
